import "../../styles/UserDashboard/EnergyOverview.scss";
import SideBar from "../../components/UserDashboard/SideBar";
import { useEffect, useState } from "react";
import EnergyHeader from "../../components/energy/energyHeader";
import EnergyTransferred from "../../components/energy/EnergyTransferred";
import BuyerConfirmed from "../../components/energy/BuyerConfirmed";
import SellerConfirmed from "../../components/energy/SellerConfirmed";
import { useNavigate } from "react-router-dom";
import { EnergyTradingIntegration } from "../../instantiateTransaction/EnergySharing";
import { useSelector } from "react-redux";
import { getUserInfo } from "../../apis/General/users";
import { useQuery } from "@tanstack/react-query";
import {listedEnergyData} from "../../apis/energySharing/index"
import { fetchUserEnergyData } from "../../apis/EnergyEfficient/EfficientApi";
import {
  getDatabase,
  ref,
  onValue,
  orderByChild,
  equalTo,
  query,
  get,
} from "firebase/database";
import WithdrawalModal from "../../components/energy/withdrawalModal";
import FormatTime from "../../utils/formatTime";
import { getEnergyListed } from "../../apis/energySharing";
import EnergySharingContract from "../../Abi/EnergySharingContract.json";
import Web3 from "web3";
import { ethers, Interface } from "ethers";

export default function EnergyOverview() {
  const auth = useSelector((state) => state.auth);
  console.log("auth", auth);


  const [generalLoading, setGeneralLoading] = useState(false);
  const [transferredOpen, setTransferredOpen] = useState(false);
  const [buyerConfirmedOpen, setBuyerConfirmedOpen] = useState(false);
  const [sellerConfirmedOpen, setSellerConfirmedOpen] = useState(false);
  const [paymentReceived, setPaymentReceived] = useState(false);
  // const [surplusEnergy, setSurplusEnergy] = useState(0);
  const [frozen, setFrozen] = useState(false);
  const [energyData, setEnergyData] = useState(0);
  const [energyDataById, setEnergyDataById] = useState(0);
  const [transferred, setTransferred] = useState(false);
  const [withdrawalOpen, setWithdrawalOpen] = useState(false);
  const [energyListed, setEnergyListed] = useState(0);
  const [walletBalance, setWalletBalance] = useState(0);
  const [excessEnergyBalance, setExcessEnergyBalance] = useState(null);
  const [account, setAccount] = useState(null);
  const [web3, setWeb3] = useState(null);
  const [contract, setContract] = useState(null);
  const [devices, setDevices] = useState([]);
const {getEnergyListedDate , setGetEnergyListedDate} = useState(0)
  const db = getDatabase();

const tableRef = ref(db, "sensors");
  const Firebase = process.env.REACT_APP_FIREBASE
  const tableRef2 = ref(db,Firebase);

  const navigate = useNavigate();

  const handleFrozenClick = () => {
    if (frozen) {
      setTransferredOpen(true);
    } else {
      setFrozen(true);
    }
  };

  useEffect(() => {
    if (window.ethereum) {
      const web3Instance = new Web3(window.ethereum);
      setWeb3(web3Instance);
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((accounts) => setAccount(accounts[0]))
        .catch((err) => {
          alert(
            "Please allow access to your MetaMask wallet to enable you exchange your CCRT"
          );
          console.error("User denied account access", err);
        });
    } else {
      console.error(
        "MetaMask is not installed. Please install it to use this app."
      );
    }
  }, []);
  
  const contractAddress = "0xb763ecF4323B5ce42c5D6a39Cc0E11c712fE104b";
  const contractABI = EnergySharingContract.abi;

  useEffect(() => {
    if (web3) {
      const contractInstance = new web3.eth.Contract(contractABI, contractAddress);
      setContract(contractInstance);
    }
  }, [web3]);
  

  useEffect(() => {
    const fetchExcessEnergyBalance = async () => {
      if (!account) {
        setExcessEnergyBalance(null);
        return;
      }
      try {
        const integration = new EnergyTradingIntegration("seller");
        await integration.init();
        const balance = await integration.getExcessEnergyBalance(account);
        setExcessEnergyBalance(balance);
        console.log("Excess Energy Balance:", balance);
        console.log("account connected for balance check:", account);

      } catch (error) {
        setExcessEnergyBalance(null);
        console.error("Failed to fetch excess energy balance", error);
      }
    };

    fetchExcessEnergyBalance();
  }, [account]); // This will re-run when account changes


  
  
  // const contract = web3
  //   ? new web3.eth.Contract(contractABI, contractAddress)
  //   : null;

  const handleGetEnergyBalance = async () => {
    const response = await getUserInfo(auth?.userInfo?.id, auth?.token);
    console.log("getUserInfo", response);
    // Map walletBalance to the correct value from the API response
    setWalletBalance(response?.data?.message?.walletBalance ?? 0);
    if (response?.data?.statusCode === 200) {
      const integration = new EnergyTradingIntegration("seller");
      await integration.init();
      const walletAddress = response?.data?.message?.walletAddress;
      const balance = await integration.getEnergyUnitBalance(walletAddress);
      // setSurplusEnergy(balance);
      setWalletBalance(response?.data?.message?.walletBalance || 0);
    }
  };

  const getListedEnergy = async () => {
    try {
      // Replace with your actual user ID logic
      const userId = auth?.userInfo?.id;
      // Fetch listed energy for the user
      const listed = await getEnergyListed(userId, auth?.token);

      console.log("Listed Energy Data:", listed);

      // Assume listed.data is an array of listed energy objects
      setEnergyListed(listed?.data || []);
    } catch (error) {
      console.error("Failed to fetch listed energy", error);
      setEnergyListed([]);
    }
    
  }

  const getEnergyListData = async () => {

    try {
      const response = await listedEnergyData(auth?.token)
      console.log("listedEnergyData", response);
      setEnergyListed(response?.data?.data?.items || [])
    } catch (error) {
      
    }
  }

  useEffect(() => {
    
    getEnergyListData()
    handleGetEnergyBalance();
    getListedEnergy();
  }, []);

  // console.log('mice', localStorage.getItem('kycCompleted') === "complete");

    const loadEvents = async () => {
  
      const newRef = ref(db, "dev-energy-sharing-table");
       onValue(newRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = Object.values(snapshot.val());
          console.log('ENERGY-SHARING', data);
          setEnergyData(data)
          console.log(energyData)
        } else {
          console.log(`No data found`);
        }
      });
    };


    
      useEffect(() => {
        const deviceQuery = query(
          tableRef,
          orderByChild("userId"),
          equalTo(auth?.userInfo?.id)
        );    const unsubscribe = onValue(deviceQuery, (snapshot) => {
              if (snapshot.exists()) {
                   const data = Object.values(snapshot.val());
                console.log("devices found", data);
                setDevices(data?.reverse());
        
                // Set up listeners for each device
                data.forEach((device) => {
                  const deviceQuery = query(
                    tableRef2,
                    orderByChild("deviceId"),
                    equalTo(device.id)
                  );
                  const listener = onValue(deviceQuery, (snapshot) => {
                    if (snapshot.exists()) {
                      const data = Object.values(snapshot.val());
                      console.log('stormzy', data);
                      
                      
        
                    }
                  });
                });
              } else {
                console.log(`No data found`);
              }
            });
        
          }, [auth?.userInfo?.id]);
        
        



  


// Move this function outside your component

// const  = 
// "GF-SLRT-6046322";
// console.log(devices)
  // Use react-query for fetching
  const firstDeviceId = devices[0]?.id;

const { data, isLoading, error } = useQuery({
  queryKey: ["energyDataById", firstDeviceId],
  queryFn: () => fetchUserEnergyData(firstDeviceId),
  enabled: !!firstDeviceId, // only run when id is available
});

if (data) {
  console.log(data);
}
if (error) {
  console.log(error);
}



    

  // const surplusId = "4a2igvnfy7ZUE7GWTnAkkqG4"

      // const energyGenerated = async () => {
        
      //   const newRef = ref(db, "dev-energy-sharing-table/"+userId);
      //   const snapshot = await get(newRef);
      //   if (snapshot.exists()) {
      //       const targetDate = snapshot.val();
      //       console.log('energyGenerated', targetDate);
          
      //   } else (error) => {
      //     console.log(error);
      //   }

      //   // const q = query(newRef, orderByChild("userId"), equalTo(userId));
      //   // onValue(q, (snapshot) => {
      //   //   if (snapshot.exists()) {
      //   //     const targetDate = snapshot.val();
      //   //     console.log('energyGenerated', targetDate);
      //   //     setTransferred(targetDate?.length > 0 ? true : false)
      //   //   } else {
      //   //     console.log(`No data found`);
      //   //   }
      //   // });

      // }
//   const userId = auth?.userInfo?.id
//   console.log("userId", userId);

//       const energyGenerated = async () => {
//   try {
//     const newRef = ref(db, "dev-energy-sharing-table/" );
//     const snapshot = await get(newRef);
//     if (snapshot.exists()) {

//       const energyDate = snapshot.val()
//       const temporaryArray = Object.keys(energyData)
//       const userEnergyDataId  = temporaryArray.keys(energyData).find(userId === user)
//       console.log('userEnergyDataId', userEnergyDataId);
//       console.log('temporaryArray', temporaryArray);
//           // const energyDate = Object.values(snapshot.val());



//       console.log('energyGenerated', energyDate);
//     } else {
//       console.log('No data found');
//     }
//   } catch (error) {
//     console.log(error);
//   }
// };

// Fetch only the current user's energy data from Firebase
// const energyGenerated = async () => {
//   try {
//     const userId = "4a2igvnfy7ZUE7GWTnAkkqG4"
//     // if (!userId) {
//     //   console.log('No userId found');
//     //   return;
//     // }
//     const db = getDatabase();
//     // Query for records where userId matches the current user
//     const userQuery = query(
//       ref(db, "dev-energy-sharing-table"),
//       orderByChild("user"),
//       equalTo(userId)
//     );
//     const snapshot = await get(userQuery);
//     if (snapshot.exists()) {
//       const userData = Object.values(snapshot.val());
//       console.log('User energy data:', userData.slice(0, 1));
//       setEnergyDataById(userData);
//     } else {
//       console.log('No data found for user');
//       setEnergyDataById([]);

//     }
//   } catch (error) {
//     console.log(error);
//   }
// };




    useEffect(() => {
      loadEvents()
      // energyGenerated()
    }, [])


  return (
    <div className="energyOverview">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="energyOverview__inner">
        <EnergyHeader />
        <div
          className={`energyOverview__inner__cards ${
            frozen || !transferred ? "energyOverview__inner__cards-frozen" : ""
          }`}
          
        >
          
          <div className="energyOverview__inner__cards__card">
            <div className="energyOverview__inner__cards__card__title">
              Total Generated Energy
            </div>
            <div className="energyOverview__inner__cards__card__subtitle">
              {energyData[energyData?.length - 1]?.energyAvailable || 0} <span>kWh</span>
            </div>

            {/* <div className="energyOverview__inner__cards__card__subsubtitle">
              <div>Compared to yesterday</div>

              <div>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_4956_26756"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="16"
                  >
                    <rect width="16" height="16" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_4956_26756)">
                    <path
                      d="M2.26634 12L1.33301 11.0667L4.86634 7.53333C5.25523 7.14444 5.72745 6.95 6.28301 6.95C6.83856 6.95 7.31079 7.14444 7.69967 7.53333L8.46634 8.3C8.59967 8.43333 8.75801 8.5 8.94134 8.5C9.12467 8.5 9.28301 8.43333 9.41634 8.3L12.383 5.33333H10.6663V4H14.6663V8H13.333V6.28333L10.3497 9.25C9.96079 9.63889 9.48856 9.83333 8.93301 9.83333C8.37745 9.83333 7.90523 9.63889 7.51634 9.25L6.73301 8.46667C6.61079 8.34444 6.45523 8.28333 6.26634 8.28333C6.07745 8.28333 5.9219 8.34444 5.79967 8.46667L2.26634 12Z"
                      fill="#0F973D"
                    />
                  </g>
                </svg>
                <div>+15%</div>
              </div>
            </div> */}
          </div>
          <div className="energyOverview__inner__cards__card">
            <div className="energyOverview__inner__cards__card__title">
              Energy Consumed
            </div>

         {
  data && data.length > 0
    ? (
        <div className="energyOverview__inner__cards__card__subtitle">
          {data[data.length - 1]?.energyConsumptionKw || 0} <span>kWh</span>
        </div>
      )
    : (
        <div className="text-xl mb-2">0 KWH</div>
      )
}

            <div className="energyOverview__inner__cards__card__subsubtitle">
              <div>Compared to yesterday</div>

              <div>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_4956_26756"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="16"
                  >
                    <rect width="16" height="16" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_4956_26756)">
                    <path
                      d="M2.26634 12L1.33301 11.0667L4.86634 7.53333C5.25523 7.14444 5.72745 6.95 6.28301 6.95C6.83856 6.95 7.31079 7.14444 7.69967 7.53333L8.46634 8.3C8.59967 8.43333 8.75801 8.5 8.94134 8.5C9.12467 8.5 9.28301 8.43333 9.41634 8.3L12.383 5.33333H10.6663V4H14.6663V8H13.333V6.28333L10.3497 9.25C9.96079 9.63889 9.48856 9.83333 8.93301 9.83333C8.37745 9.83333 7.90523 9.63889 7.51634 9.25L6.73301 8.46667C6.61079 8.34444 6.45523 8.28333 6.26634 8.28333C6.07745 8.28333 5.9219 8.34444 5.79967 8.46667L2.26634 12Z"
                      fill="#0F973D"
                    />
                  </g>
                </svg>
                <div>+15%</div>
              </div>
            </div>
          </div>


          <div className="energyOverview__inner__cards__card"
          onClick={() => setPaymentReceived(true)}
          >


            <div className="energyOverview__inner__cards__card__title">
              Surplus Energy
            </div>
            <div className="energyOverview__inner__cards__card__subtitle">
            <span>
      {excessEnergyBalance !== null ? `${excessEnergyBalance} kWh` : "Loading..."}
    </span>
</div>
            {/* {
              data && data.length > 0 && (
                <div className="energyOverview__inner__cards__card__subtitle">
                  <span>{excessEnergyBalance !== null ? excessEnergyBalance : ""}kWh</span>
                </div>
              )
            } */}
{/* s
                  {Array.isArray(energyDataById) && energyDataById.slice(-1).map((item, idx) => (

            <div key={idx} className="energyOverview__inner__cards__card__subtitle">
              {item.excessEnergy} <span>kWh</span>
            </div>
          ))} */}
        

   



            <div className="energyOverview__inner__cards__card__subsubtitle">
              <div>Compared to yesterday</div>

              <div>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_4956_26756"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="16"
                  >
                    <rect width="16" height="16" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_4956_26756)">
                    <path
                      d="M2.26634 12L1.33301 11.0667L4.86634 7.53333C5.25523 7.14444 5.72745 6.95 6.28301 6.95C6.83856 6.95 7.31079 7.14444 7.69967 7.53333L8.46634 8.3C8.59967 8.43333 8.75801 8.5 8.94134 8.5C9.12467 8.5 9.28301 8.43333 9.41634 8.3L12.383 5.33333H10.6663V4H14.6663V8H13.333V6.28333L10.3497 9.25C9.96079 9.63889 9.48856 9.83333 8.93301 9.83333C8.37745 9.83333 7.90523 9.63889 7.51634 9.25L6.73301 8.46667C6.61079 8.34444 6.45523 8.28333 6.26634 8.28333C6.07745 8.28333 5.9219 8.34444 5.79967 8.46667L2.26634 12Z"
                      fill="#0F973D"
                    />
                  </g>
                </svg>
                <div>+15%</div>
              </div>
            </div>
          </div>



          {!transferred && (
            <div
              className="energyOverview__inner__cards__card energyOverview__inner__cards__card-listed"
              onClick={handleFrozenClick}
            >
              {frozen == true && (
                <div className="energyOverview__inner__cards__card-listed__frozen">
                  Locked
                </div>
              )}
              <div className="energyOverview__inner__cards__card__title">
                Energy Listed To Buy
              </div>
        
              
              {/* map out listed energy */}
              {Array.isArray(energyListed) && energyListed.length > 0 ? (
                energyListed.slice(0, 1).map((item, idx) => (
                  <div key={idx}>
                    <div className="energyOverview__inner__cards__card__subtitle">
                      <span>{item.items} kWh</span>
                    </div>
              
                  </div>
                ))
              ) : (
                <>
                  <div className="energyOverview__inner__cards__card__subtitle">
                    <span>0 kWh</span>
                  </div>
                  <div className="energyOverview__inner__cards__card__time">
                    Listed: --
                  </div>
                </>
              )}
            </div>
          )}
          <div className="energyOverview__inner__cards__card"
          onClick={() => setWithdrawalOpen(true)}
          >
            {/* wallet ballance output  */}
            <div className="energyOverview__inner__cards__card__title">
              Wallet Balance
            </div>

            <div className="energyOverview__inner__cards__card__subtitle">
              ₦{Number(walletBalance).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}{" "}
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 8C14 8.8 11.3133 12 8 12C4.68667 12 2 8.8 2 8C2 7.2 4.68667 4 8 4C11.3133 4 14 7.2 14 8Z"
                  stroke="#BDCFC6"
                  stroke-width="1.33333"
                />
                <path
                  d="M10 8C10 8.53043 9.78929 9.03914 9.41421 9.41421C9.03914 9.78929 8.53043 10 8 10C7.46957 10 6.96086 9.78929 6.58579 9.41421C6.21071 9.03914 6 8.53043 6 8C6 7.46957 6.21071 6.96086 6.58579 6.58579C6.96086 6.21071 7.46957 6 8 6C8.53043 6 9.03914 6.21071 9.41421 6.58579C9.78929 6.96086 10 7.46957 10 8Z"
                  stroke="#BDCFC6"
                  stroke-width="1.33333"
                />
              </svg>
            </div>

            {/* <div className="energyOverview__inner__cards__card__time">
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.9987 0.333984C10.6807 0.333984 13.6654 3.31865 13.6654 7.00065C13.6654 10.6827 10.6807 13.6673 6.9987 13.6673C3.3167 13.6673 0.332031 10.6827 0.332031 7.00065C0.332031 3.31865 3.3167 0.333984 6.9987 0.333984ZM6.9987 1.66732C5.58421 1.66732 4.22766 2.22922 3.22746 3.22941C2.22727 4.22961 1.66536 5.58616 1.66536 7.00065C1.66536 8.41514 2.22727 9.77169 3.22746 10.7719C4.22766 11.7721 5.58421 12.334 6.9987 12.334C8.41319 12.334 9.76974 11.7721 10.7699 10.7719C11.7701 9.77169 12.332 8.41514 12.332 7.00065C12.332 5.58616 11.7701 4.22961 10.7699 3.22941C9.76974 2.22922 8.41319 1.66732 6.9987 1.66732ZM6.9987 3.00065C7.16199 3.00067 7.31959 3.06062 7.44161 3.16913C7.56364 3.27763 7.64159 3.42715 7.6607 3.58932L7.66536 3.66732V6.72465L9.47003 8.52932C9.5896 8.64929 9.65901 8.81027 9.66418 8.97957C9.66935 9.14887 9.60989 9.31379 9.49786 9.44084C9.38584 9.56788 9.22966 9.64752 9.06105 9.66358C8.89243 9.67965 8.72402 9.63093 8.59003 9.52732L8.52736 9.47198L6.52736 7.47198C6.42375 7.36828 6.35721 7.23332 6.33803 7.08798L6.33203 7.00065V3.66732C6.33203 3.49051 6.40227 3.32094 6.52729 3.19591C6.65232 3.07089 6.82189 3.00065 6.9987 3.00065Z"
                  fill="#BDCFC6"
                />
              </svg>
              48hrs ago
            </div> */}
          </div>
        </div>

        <div className="energyOverview__inner__actions-title">
          Quick Actions
        </div>
        <div className="energyOverview__inner__actions">
          <div
            className="energyOverview__inner__actions__card"
            onClick={() => navigate("/list-energy")}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_4960_14470"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_4960_14470)">
                <path
                  d="M6 22C5.16667 22 4.45833 21.7083 3.875 21.125C3.29167 20.5417 3 19.8333 3 19V16H6V2H21V19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22H6ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19V4H8V16H17V19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20ZM9 9V7H18V9H9ZM9 12V10H18V12H9ZM6 20H15V18H5V19C5 19.2833 5.09583 19.5208 5.2875 19.7125C5.47917 19.9042 5.71667 20 6 20ZM6 20H5H15H6Z"
                  fill="#2C9963"
                />
              </g>
            </svg>

            <div>
              <div className="energyOverview__inner__actions__card__title">
                List Energy
              </div>
              <div className="energyOverview__inner__actions__card__subtitle">
                Sell your excess energy instantly and get paid seamlessly.
              </div>
            </div>
          </div>
          <div
            className="energyOverview__inner__actions__card"
            onClick={() => navigate("/energy-listing")}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_4960_21047"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_4960_21047)">
                <path
                  d="M21.0255 11.05V19C21.0255 19.55 20.8296 20.0208 20.438 20.4125C20.0463 20.8042 19.5755 21 19.0255 21H5.02545C4.47545 21 4.00462 20.8042 3.61295 20.4125C3.22129 20.0208 3.02545 19.55 3.02545 19V11.05C2.64212 10.7 2.34629 10.25 2.13795 9.7C1.92962 9.15 1.92545 8.55 2.12545 7.9L3.17545 4.5C3.30879 4.06667 3.54629 3.70833 3.88795 3.425C4.22962 3.14167 4.62545 3 5.07545 3H18.9755C19.4255 3 19.8171 3.1375 20.1505 3.4125C20.4838 3.6875 20.7255 4.05 20.8755 4.5L21.9255 7.9C22.1255 8.55 22.1213 9.14167 21.913 9.675C21.7046 10.2083 21.4088 10.6667 21.0255 11.05ZM14.2255 10C14.6755 10 15.0171 9.84583 15.2505 9.5375C15.4838 9.22917 15.5755 8.88333 15.5255 8.5L14.9755 5H13.0255V8.7C13.0255 9.05 13.1421 9.35417 13.3755 9.6125C13.6088 9.87083 13.8921 10 14.2255 10ZM9.72545 10C10.1088 10 10.4213 9.87083 10.663 9.6125C10.9046 9.35417 11.0255 9.05 11.0255 8.7V5H9.07545L8.52545 8.5C8.45879 8.9 8.54629 9.25 8.78795 9.55C9.02962 9.85 9.34212 10 9.72545 10ZM5.27545 10C5.57545 10 5.83795 9.89167 6.06295 9.675C6.28795 9.45833 6.42545 9.18333 6.47545 8.85L7.02545 5H5.07545L4.07545 8.35C3.97545 8.68333 4.02962 9.04167 4.23795 9.425C4.44629 9.80833 4.79212 10 5.27545 10ZM18.7755 10C19.2588 10 19.6088 9.80833 19.8255 9.425C20.0421 9.04167 20.0921 8.68333 19.9755 8.35L18.9255 5H17.0255L17.5755 8.85C17.6255 9.18333 17.763 9.45833 17.988 9.675C18.213 9.89167 18.4755 10 18.7755 10ZM5.02545 19H19.0255V11.95C18.9421 11.9833 18.888 12 18.863 12H18.7755C18.3255 12 17.9296 11.925 17.588 11.775C17.2463 11.625 16.9088 11.3833 16.5755 11.05C16.2755 11.35 15.9338 11.5833 15.5505 11.75C15.1671 11.9167 14.7588 12 14.3255 12C13.8755 12 13.4546 11.9167 13.063 11.75C12.6713 11.5833 12.3255 11.35 12.0255 11.05C11.7421 11.35 11.413 11.5833 11.038 11.75C10.663 11.9167 10.2588 12 9.82545 12C9.34212 12 8.90462 11.9167 8.51295 11.75C8.12129 11.5833 7.77545 11.35 7.47545 11.05C7.12545 11.4 6.77962 11.6458 6.43795 11.7875C6.09629 11.9292 5.70879 12 5.27545 12H5.16295C5.12129 12 5.07545 11.9833 5.02545 11.95V19Z"
                  fill="#2C9963"
                />
              </g>
            </svg>

            <div>
              <div className="energyOverview__inner__actions__card__title">
                Buy/Sell Energy
              </div>
              <div className="energyOverview__inner__actions__card__subtitle">
                Sell your excess energy instantly and get paid seamlessly.
              </div>
            </div>
          </div>
          <div
            className="energyOverview__inner__actions__card"
            onClick={() => setSellerConfirmedOpen(true)}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5 3.00087C13.837 3.00087 13.2011 3.26426 12.7322 3.7331C12.2634 4.20195 12 4.83783 12 5.50087C12 6.16391 12.2634 6.7998 12.7322 7.26864C13.2011 7.73748 13.837 8.00087 14.5 8.00087C15.163 8.00087 15.7989 7.73748 16.2678 7.26864C16.7366 6.7998 17 6.16391 17 5.50087C17 4.83783 16.7366 4.20195 16.2678 3.7331C15.7989 3.26426 15.163 3.00087 14.5 3.00087ZM10 5.50087C9.99985 4.73492 10.1952 3.98161 10.5676 3.31227C10.94 2.64293 11.477 2.07972 12.1279 1.67597C12.7788 1.27221 13.522 1.04128 14.2871 1.00504C15.0522 0.9688 15.8139 1.12845 16.5 1.46887C17.1861 1.12886 17.9476 0.969529 18.7124 1.00597C19.4773 1.04241 20.2201 1.27342 20.8708 1.67712C21.5214 2.08083 22.0583 2.64388 22.4306 3.313C22.8029 3.98212 22.9982 4.73516 22.9982 5.50087C22.9982 6.26658 22.8029 7.01963 22.4306 7.68874C22.0583 8.35786 21.5214 8.92091 20.8708 9.32462C20.2201 9.72833 19.4773 9.95933 18.7124 9.99577C17.9476 10.0322 17.1861 9.87289 16.5 9.53287C15.8139 9.87329 15.0522 10.0329 14.2871 9.9967C13.522 9.96046 12.7788 9.72953 12.1279 9.32578C11.477 8.92202 10.94 8.35881 10.5676 7.68947C10.1952 7.02013 9.99985 6.26682 10 5.50087ZM18.25 7.98887C18.332 7.99687 18.4153 8.00087 18.5 8.00087C18.8384 8.00014 19.1731 7.93072 19.4839 7.79682C19.7946 7.66291 20.075 7.46732 20.3079 7.22187C20.5409 6.97643 20.7216 6.68625 20.8391 6.36892C20.9566 6.05158 21.0084 5.7137 20.9915 5.37573C20.9745 5.03777 20.8891 4.70676 20.7405 4.40277C20.5919 4.09877 20.3831 3.82811 20.1268 3.60719C19.8704 3.38627 19.5719 3.21969 19.2493 3.11753C18.9267 3.01537 18.5868 2.97976 18.25 3.01287C18.7392 3.75041 19.0001 4.61583 19 5.50087C19.0001 6.38591 18.7392 7.25134 18.25 7.98887ZM8.435 13.2509C8.27081 13.2504 8.10814 13.2824 7.95629 13.3448C7.80444 13.4073 7.66638 13.499 7.55 13.6149L5.5 15.6649V19.5009H11.127L16.93 18.0509L20.462 16.5429C20.5823 16.4779 20.6744 16.3707 20.7205 16.242C20.7667 16.1133 20.7637 15.972 20.7122 15.8454C20.6606 15.7187 20.5641 15.6156 20.4412 15.5557C20.3182 15.4958 20.1775 15.4834 20.046 15.5209L20.026 15.5259L13.614 17.0009H10V15.0009H13.125C13.3571 15.0009 13.5796 14.9087 13.7437 14.7446C13.9078 14.5805 14 14.3579 14 14.1259C14 13.8938 13.9078 13.6712 13.7437 13.5072C13.5796 13.3431 13.3571 13.2509 13.125 13.2509H8.435ZM15.987 14.4029L19.539 13.5859C19.9173 13.4864 20.3134 13.4749 20.6968 13.5524C21.0802 13.6298 21.4408 13.7941 21.7509 14.0326C22.0609 14.2711 22.3122 14.5775 22.4854 14.9282C22.6586 15.2789 22.7491 15.6647 22.75 16.0559C22.7496 16.5307 22.6171 16.9961 22.3674 17.4C22.1177 17.8038 21.7606 18.1303 21.336 18.3429L21.309 18.3569L17.569 19.9519L11.373 21.5009H0V14.2509H4.086L6.138 12.1989C6.44034 11.8976 6.79907 11.6588 7.1937 11.4961C7.58834 11.3334 8.01116 11.2501 8.438 11.2509H13.125C13.5259 11.2508 13.9225 11.3346 14.2891 11.4969C14.6557 11.6592 14.9843 11.8964 15.2539 12.1932C15.5234 12.49 15.7278 12.84 15.8541 13.2205C15.9804 13.6011 16.0256 14.0038 15.987 14.4029ZM3.5 16.2509H2V19.5009H3.5V16.2509Z"
                fill="#2C9963"
              />
            </svg>

            <div>
              <div className="energyOverview__inner__actions__card__title">
                Withdraw
              </div>
              <div className="energyOverview__inner__actions__card__subtitle">
                Sell your excess energy instantly and get paid seamlessly.
              </div>
            </div>
          </div>
          <div
            className="energyOverview__inner__actions__card"
            onClick={() => setBuyerConfirmedOpen(true)}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.19994 14.222V4C3.19994 3.46957 3.41065 2.96086 3.78572 2.58579C4.1608 2.21071 4.6695 2 5.19994 2H18.7999C19.3304 2 19.8391 2.21071 20.2142 2.58579C20.5892 2.96086 20.7999 3.46957 20.7999 4V14.222M3.19994 14.222H20.7999M3.19994 14.222L1.71994 19.456C1.63588 19.7534 1.62188 20.0662 1.67904 20.3699C1.73619 20.6736 1.86295 20.9599 2.04936 21.2064C2.23577 21.4529 2.47676 21.6528 2.75343 21.7905C3.03009 21.9282 3.3349 21.9999 3.64394 22H20.3559C20.665 21.9999 20.9698 21.9282 21.2464 21.7905C21.5231 21.6528 21.7641 21.4529 21.9505 21.2064C22.1369 20.9599 22.2637 20.6736 22.3208 20.3699C22.378 20.0662 22.364 19.7534 22.2799 19.456L20.7999 14.222"
                stroke="#2C9963"
                stroke-width="1.5"
              />
              <path
                d="M12 5V8M12 11.01L12.01 10.999M11 19H13"
                stroke="#2C9963"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div>
              <div className="energyOverview__inner__actions__card__title">
                Dispute transaction
              </div>
              <div className="energyOverview__inner__actions__card__subtitle">
                Sell your excess energy instantly and get paid seamlessly.
              </div>
            </div>
          </div>
        </div>

        <div className="management_card_group">
          <div className="card1">
            <div className="title_group">
              <div>Energy Generated</div>
              <div className="title_group__flex"></div>

              {/* <form className="date_group">
                    <div>
                      <div>From</div>
                      <input
                        type="date"
                        value={from}
                        onChange={handleFromChange}
                      />
                      {inRangeLoading && <div>Loading...</div>}
                    </div>
                    <div>
                      <div>To</div>
                      <input type="date" value={to} onChange={handleToChange} />
                    </div>
                  </form> */}
            </div>

            <div className="emission_table" id="table">
              {!generalLoading && (
                <div className="table_header_container">
                  <div className="table_header first">Time (AM/PM)</div>
                  <div className="table_header">Energy consumption (kWh)</div>
                  <div className="table_header">Amount left (kWh)</div>
                  <div className="table_header last">Source</div>
                </div>
              )}
              {generalLoading ? (
                <>
                  {/* <Skeleton
                        height={40}
                        borderRadius={4}
                        count={5}
                        style={{ marginTop: "24px" }}
                      /> */}
                </>
              ) : (
                <>
                  <>
 {
                    data && data.length === 0 && (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          color: "#999",
                        }}
                      >
                        No data available
                      </div>
              )
            }
                  {Array.isArray(data) && data.slice(-50).reverse().map((item, idx) => (
    <div key={idx} style={{display: 'flex', borderBottom: '1px solid #f5f5f5', fontSize: 14}}>
      <div style={{flex: 2, marginLeft:24, paddingLeft:25, paddingTop:25, paddingBottom:25}}>{item.created_at ? FormatTime(item.created_at).toLocaleString() : "--"}</div>
      <div style={{flex: 1,  padding:25 , marginLeft:-220, marginRight:20}}>{item.energyConsumptionKw ?? "--"}</div>
      <div style={{flex: 1, padding:25}}>{item.amountLeft ?? "--"}</div>
      <div style={{flex: 1, padding:25}}>{item.excessEnergy ?? "--nm "}</div>



      
    </div>
  ))}
                    {/* <div className="table_body_container">
                      <div>09:20am</div>
                      <div>900</div>
                      <div>2,727.27</div>
                      <div>Solar</div>
                    </div>
                    <div className="table_body_container mobile">
                      <div>09:20am</div>
                      <div>900</div>
                      <div>2,727.27</div>
                      <div>Solar</div>
                    </div> */}
                  </>
                </>
              )}
            </div>
          </div>
          <div className="card2"></div>
        </div>
      </div>

      <EnergyTransferred
        title="Congratulations"
        subtitle={`Your ${energyListed}kWh energy has been unlocked and successfully transferred. Check your wallet balance for payment.`}
        open={transferredOpen}
        setOpen={setTransferredOpen}
        onConfirm={() => setTransferred(true)}
      />
      <BuyerConfirmed
        open={buyerConfirmedOpen}
        setOpen={setBuyerConfirmedOpen}
        onConfirm={() => setTransferred(true)}
      />
      <SellerConfirmed
        title="You've gotten a seller"
        subtitle={`A seller has agreed to provide ${energyListed}kwh of energy. Proceed to complete the transaction.`}
        buttonTexts={["Cancel", "Proceed"]}
        buttonFunctions={[
          () => setSellerConfirmedOpen(false),
          () => navigate("/pay-for-energy"),
        ]}
        open={sellerConfirmedOpen}
        setOpen={setSellerConfirmedOpen}
      />
      <SellerConfirmed
        title="Have you received payment?"
        subtitle="Click yes if you have received payment for the energy."
        buttonTexts={["Cancel", "Yes"]}
        buttonFunctions={[
          () => setPaymentReceived(false),
          () => setPaymentReceived(false),
        ]}
        open={paymentReceived}
        setOpen={setPaymentReceived}
      />
      <WithdrawalModal open={withdrawalOpen} setOpen={setWithdrawalOpen} />
    </div>
  );
}

